import React from 'react';

import type { Name as NameType } from '@/typings/api-models';

import { InputOnBlur } from '../Input';
import Fieldset from '../shared/Fieldset';

import s from './Name.module.scss';

export type NameOnBlurProps = {
  label: string;
  description?: string;
  disabled?: boolean;
  value: NameType | null;
  placeholder?: string;
  error?:
    | string
    | {
        firstName?: string;
        lastName?: string;
      };
  hasError?: boolean;
  optional?: boolean;
  hint?: string;
  onChange: (value: NameType) => void;
  onBlur?: () => void;
  onFocus?: () => void;
};

export const DEFAULT_VALUE: NameType = {
  firstName: '',
  lastName: '',
  middleName: '',
};

const NameOnBlur: React.FC<NameOnBlurProps> = ({
  label,
  description,
  disabled,
  value,
  placeholder,
  error,
  hasError,
  optional,
  hint,
  onChange,
  onBlur,
  onFocus,
}) => {
  const handleInputChange = (field: keyof NameType) => (thisValue: string) => {
    onChange({
      ...DEFAULT_VALUE,
      ...(value || {}),
      [field]: thisValue,
    });
  };

  return (
    <Fieldset
      label={label}
      description={description}
      required={!optional}
      hint={hint}
      error={typeof error === 'string' ? error : undefined}
    >
      <div className={s['name-inputs']}>
        <InputOnBlur
          label='First Name'
          compact
          value={value?.firstName ?? DEFAULT_VALUE.firstName}
          placeholder={placeholder}
          optional={optional}
          onChange={handleInputChange('firstName')}
          disabled={disabled}
          onBlur={onBlur}
          onFocus={onFocus}
          error={typeof error === 'object' ? error.firstName : undefined}
          hasError={(typeof error === 'string' && !!error) || !!hasError}
        />
        <InputOnBlur
          optional
          label='Middle Name'
          compact
          value={value?.middleName ?? DEFAULT_VALUE.middleName}
          placeholder={placeholder}
          onChange={handleInputChange('middleName')}
          disabled={disabled}
          onBlur={onBlur}
          onFocus={onFocus}
        />
        <InputOnBlur
          label='Last Name'
          compact
          value={value?.lastName ?? DEFAULT_VALUE.lastName}
          placeholder={placeholder}
          optional={optional}
          onChange={handleInputChange('lastName')}
          disabled={disabled}
          onBlur={onBlur}
          error={typeof error === 'object' ? error.lastName : undefined}
          hasError={(typeof error === 'string' && !!error) || !!hasError}
          onFocus={onFocus}
        />
      </div>
    </Fieldset>
  );
};

export default NameOnBlur;
